var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigmaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 57 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.262 85.6342C22.1223 85.6342 28.508 79.2528 28.508 71.3822V57.1301H14.262C6.40165 57.1301 0.0159912 63.5115 0.0159912 71.3822C0.0159912 79.2528 6.40165 85.6342 14.262 85.6342Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0159912 42.8779C0.0159912 35.0142 6.40165 28.6259 14.262 28.6259H28.508V57.1299H14.262C6.40165 57.1299 0.0159912 50.7485 0.0159912 42.8779Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0159912 14.3736C0.0159912 6.50995 6.40165 0.121582 14.262 0.121582H28.508V28.6257H14.262C6.40165 28.6257 0.0159912 22.2443 0.0159912 14.3736Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5081 0.121704H42.7541C50.6144 0.121704 57.0001 6.51007 57.0001 14.3737C57.0001 22.2444 50.6214 28.6258 42.7541 28.6258H28.5081V0.121704Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0001 42.8779C57.0001 50.7485 50.6214 57.1299 42.7541 57.1299C34.8868 57.1299 28.5081 50.7485 28.5081 42.8779C28.5081 35.0142 34.8868 28.6259 42.7541 28.6259C50.6214 28.6259 57.0001 35.0142 57.0001 42.8779Z",
    fill: "#1ABCFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaIcon);
export default __webpack_public_path__ + "static/media/figma-icon.21a5c656a251bf0d7506a244f0e04d2f.svg";
export { ForwardRef as ReactComponent };